import type { Metric } from '@enums';
import { type InsightSeriesSuccess, MAX_VALUES, sliceChartData } from '@utils';
import type { ChartType } from 'types/common';
import type { InsightChart } from 'types/schema';
import Chart from '../../../charts/Chart';
import Styled from './InsightChartContent.styled';
import InsightFooter from './InsightFooter';

interface Props {
  type: ChartType;
  metric: Metric;
  insight: InsightChart;
  series: InsightSeriesSuccess;
}

function InsightChartContent({ type, metric, insight, series }: Props) {
  const title = insight.question_calculations[0].question.question_name;
  const insightText = insight?.insight?.text;

  return (
    <Styled.Wrapper>
      <Styled.Title>{title}</Styled.Title>
      {insightText ? (
        <Styled.InsightText>{insightText}</Styled.InsightText>
      ) : null}
      <Chart
        type={type}
        metric={metric}
        hasMultipleAudiences={series.hasMultipleAudiences}
        data={sliceChartData(series?.chartData ?? [], MAX_VALUES[type])}
      />
      <InsightFooter
        data={{
          datasets: insight.datasets,
          timeframe_groups: insight.timeframe_groups,
          location_groups: insight.location_groups
        }}
        shouldOpenDialog={false}
      />
    </Styled.Wrapper>
  );
}

export default InsightChartContent;
